// import React from "react"; // Added React import for completeness
// import { Link } from "react-router-dom";
// import brandlogo from "../../Assets/VetrinaLogo.png"; // Assuming this path is correct

// export default function Navbar() {
//   return (
//     <>
//       <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
//         <div className="container-fluid px-3">
//           {/* Brand Logo - Stays on the left */}
//           <Link className="navbar-brand" to={"/"}>
//             <img
//               src={brandlogo}
//               alt="Vetrina Logo"
//               style={{ height: "1.7em", width: "auto", maxHeight: "40px" }}
//             />
//           </Link>

//           {/* START: Centered Title */}
//           <div className="navbar-title-container-public"> {/* Different class name to avoid conflicts */}
//             <h1 className="navbar-title-public">VetTalent Hub</h1>
//           </div>
//           {/* END: Centered Title */}

//           {/* Navbar Toggler Button (appears on smaller screens) */}
//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#mainNavbarContent"
//             aria-controls="mainNavbarContent"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>

//           {/* Collapsible Navbar Content */}
//           <div className="collapse navbar-collapse" id="mainNavbarContent">
//             {/* Navigation links list - 'ms-auto' pushes this block to the right */}
//             <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
//               <li className="nav-item">
//                 <Link className="nav-link" to={"/sign-in"}>
//                   Login
//                 </Link>
//               </li>
//               <li className="nav-item">
//                 <Link className="nav-link" to={"/sign-up"}>
//                   Register
//                 </Link>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>

//       {/* Add CSS for the title directly here or in your main CSS file if preferred */}
//       <style jsx>{`
//         /* Ensure parent .container-fluid and .navbar can accommodate the centered title */
//         .navbar .container-fluid {
//           position: relative; /* Needed for absolute positioning of the title container */
//         }

//         .navbar-title-container-public {
//           position: absolute;
//           left: 50%;
//           transform: translateX(-50%);
//           display: flex;
//           align-items: center;
//           /* Adjust top position if your navbar height is different */
//           top: 50%; 
//           transform: translate(-50%, -50%);
//         }

//         .navbar-title-public {
//           font-size: 1.5em; /* Adjust size as needed */
//           font-weight: 700;
//           margin: 0;
//           background: linear-gradient(90deg, #8E2DE2, #4A00E0, #00c6ff, #8E2DE2); /* Purple-Blue-LightBlue gradient */
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           background-size: 300% 100%; /* Make the gradient wider than the text for animation */
//           animation: shimmerPublic 5s linear infinite; /* Different animation name if styles conflict */
//           text-shadow: 0 0 5px rgba(255, 255, 255, 0.3), /* Soft white glow */
//                        0 0 10px rgba(142, 45, 226, 0.2); /* Faint purple glow */
//         }

//         @keyframes shimmerPublic { /* Different animation name */
//           0% {
//             background-position: 0% 50%;
//           }
//           100% {
//             background-position: 100% 50%;
//           }
//         }

//         /* Responsive adjustments for the title */
//         @media (max-width: 991.98px) { /* Before it collapses to burger menu (Bootstrap 'lg' breakpoint) */
//           .navbar-title-container-public {
//             /* Hide or significantly reduce prominence when navbar is about to collapse,
//                as the toggler button will appear. Or, keep it and let toggler overlap. */
//              left: auto; /* Reset left for flex behavior if needed when not centered */
//              position: static; /* Let it flow with other items or hide */
//              transform: none;
//              margin: 0 auto; /* Attempt to center if static */
//              /* OR simply hide it: */
//              /* display: none; */
//           }
//            .navbar-title-public {
//             font-size: 1.3em; /* Slightly smaller */
//           }
//         }

//         @media (max-width: 768px) {
//             .navbar-title-container-public {
//                  display: none; /* Often best to hide it when the burger menu is active to avoid clutter */
//             }
//         }
//       `}</style>
//     </>
//   );
// }

import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import brandlogo from "../../Assets/VetrinaLogo.png";

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();

  const isHomePage = location.pathname === "/";

  const handleStartHereClick = () => {
    navigate("/sign-up");
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
        <div className="container-fluid px-3">
          {/* Brand Logo */}
          <Link className="navbar-brand" to={"/"}>
            <img
              src={brandlogo}
              alt="Vetrina Logo"
              style={{ height: "1.7em", width: "auto", maxHeight: "40px" }}
            />
          </Link>

          {/* Centered Title */}
          <div className="navbar-title-container-public">
            <h1 className="navbar-title-public">VetTalent Hub</h1>
          </div>

          {/* Toggler for Mobile */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbarContent"
            aria-controls="mainNavbarContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Collapsible Content */}
          <div className="collapse navbar-collapse" id="mainNavbarContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 d-flex align-items-center">
              {isHomePage && (
                <li className="nav-item me-3">

                  <button
                    className="btn start-here-btn ms-2"
                    onClick={handleStartHereClick}
                  >
                    🚀 Start Here
                  </button>
                </li>
              )}
              <li className="nav-item">
                <Link className="nav-link" to={"/sign-in"}>
                  Login
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/sign-up"}>
                  Register
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <style jsx>{`
        .navbar .container-fluid {
          position: relative;
        }

        .navbar-title-container-public {
          position: absolute;
          left: 50%;
          transform: translate(-50%, -50%);
          top: 50%;
          display: flex;
          align-items: center;
        }

        .navbar-title-public {
          font-size: 2.2em;
          font-weight: 700;
          margin: 0;
          background: linear-gradient(90deg, #a82682, #a92984, #d46b0c, #a82682);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-size: 300% 100%;
          animation: shimmerPublic 5s linear infinite;
          text-shadow: 0 0 5px rgba(255, 255, 255, 0.3),
            0 0 10px rgba(142, 45, 226, 0.2);
        }

        @keyframes shimmerPublic {
          0% {
            background-position: 0% 50%;
          }
          100% {
            background-position: 100% 50%;
          }
        }

        /* Updated Start Here Button Styling with your gradient */
        .start-here-btn {
          background: linear-gradient(90deg, #ef7f1a, #a82682);
          color: white;
          font-weight: 600;
          border: none;
          padding: 0.5em 1.3em;
          border-radius: 50px;
          font-size: 1rem;
          box-shadow: 0 0 12px rgba(168, 38, 130, 0.4);
          transition: transform 0.2s ease, box-shadow 0.3s ease;
          animation: pulseGlow 2s infinite;
        }

        .start-here-btn:hover {
          transform: scale(1.05);
          box-shadow: 0 0 20px rgba(168, 38, 130, 0.6);
        }

        @keyframes pulseGlow {
          0% {
            box-shadow: 0 0 12px rgba(168, 38, 130, 0.4);
          }
          50% {
            box-shadow: 0 0 20px rgba(239, 127, 26, 0.7);
          }
          100% {
            box-shadow: 0 0 12px rgba(168, 38, 130, 0.4);
          }
        }

        @media (max-width: 991.98px) {
          .navbar-title-container-public {
            left: auto;
            position: static;
            transform: none;
            margin: 0 auto;
          }
          .navbar-title-public {
            font-size: 1.3em;
          }
        }

        @media (max-width: 768px) {
          .navbar-title-container-public {
            display: none;
          }
        }
      `}</style>
    </>
  );
}
